import { FR_HEADER } from "./const-from-env";

export const fromSystem = {
    paymentGateway: FR_HEADER
}